import React from 'react';
import { withTranslation, WithTranslation } from '@wix/wix-i18n-config';
import s from './MobilePrice.scss';
import { isLocalCurrencyOnRight } from '../../../services/window-utils';

export interface PriceProps extends WithTranslation {
  amount: number;
  currency: string;
}

class MobilePrice extends React.Component<PriceProps> {
  render() {
    const { t, amount, currency } = this.props;
    const rightCurrency = isLocalCurrencyOnRight() ? currency : null;
    const leftCurrency = !isLocalCurrencyOnRight() ? currency : null;

    return (
      <div className={s.root} data-hook="price-component">
        <div className={s.price} data-hook="price">
          <div className={s.currencyLeft} data-hook="price-currency-left">
            {leftCurrency}
          </div>
          <div className={s.amount} data-hook="price-amount">
            {amount}
          </div>
          <div className={s.currencyRight} data-hook="price-currency-right">
            {rightCurrency}
          </div>
          <div className={s.aMonth} data-hook="price-aMonth">
            {t('mobile.aMonth')}
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation()(MobilePrice);
